import { render } from "./ProductThumbHoverZoom.vue?vue&type=template&id=e036a7e6&scoped=true"
import script from "./ProductThumbHoverZoom.vue?vue&type=script&lang=js"
export * from "./ProductThumbHoverZoom.vue?vue&type=script&lang=js"

import "./ProductThumbHoverZoom.vue?vue&type=style&index=0&id=e036a7e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e036a7e6"]])

export default __exports__